
import api from '@/api';

const namespaced = true;

const state = {
};

const mutations = {
};

const actions = {
  async create(store, report) {
    let createdReport = null;
    try {
      const res = await api.post(`/intervention-reports`, report);
      createdReport = res.data;
    } catch (e) {} // eslint-disable-line

    return createdReport;
  },
  async sendByEmail(store, { reportId, email, message }) {
    try {
      await api.post(`/intervention-reports/${reportId}/send`, { email, message });

      return true;
    } catch (e) {
      return false;
    }
  },
};

const getters = {
};

export default {
  namespaced, state, mutations, actions, getters,
};
